import React, { Component } from "react";
import PropTypes from "prop-types";

import Header from "../../../components/Library/Header";

import styles from "./SubscriptionHeader.css";

class SubscriptionHeader extends Component {
  render() {
    return (
      <Header
        className={styles.newsletter}
        subText={this.props.subText}
        text={this.props.text}
        subscription={this.props.subscription}
        queryParams={this.props.queryParams}
      />
    );
  }
}

SubscriptionHeader.propTypes = {
  subText: PropTypes.string,
  text: PropTypes.string,
  queryParams: PropTypes.object,
};

SubscriptionHeader.defaultProps = {
  text: "Newsletters",
};

export default SubscriptionHeader;
